import React, { useEffect } from "react";
import { marked } from "marked";
import Input from "../../components/Input";
import Close from "../../components/Close";
import IaIcon from "../../components/IaIcon";
import IaUserIcon from "../../components/IaUserIcon";

function IaConversation(props) {
  const {
    iaResponse,
    iaHeader,
    iaAsks,
    iaAskText,
    setIaAskText,
    sendIaAsk,
    title,
    maxAsks,
    currentAsk,
    exceedAsksLimit,
    exceedAsksLimitAvailable,
    handleCloseAi,
  } = props;
  const [iaResponseParsed, setIaResponseParsed] = React.useState("");

  useEffect(() => {
    const text = marked.parse(iaResponse);
    setIaResponseParsed(text);
  }, [iaResponse]);

  return (
    <div className="c-ia-conversation">
      <button
        type="button"
        className="c-ia-conversation__close"
        onClick={() => handleCloseAi(false)}
      >
        <Close color={"#fc5c65"} />
      </button>

      <h4 className="c-ia-conversation__title">{iaHeader}</h4>

      <div className="c-ia-conversation__ia-text-container">
        <div className="c-ia-conversation__ia-text-ia-icon">
          <IaIcon />
        </div>
        <p
          className="c-ia-conversation__ia-text"
          dangerouslySetInnerHTML={{
            __html: iaResponseParsed,
          }}
        ></p>
      </div>

      <div style={{ marginTop: 16 }}>
        <form>
          {iaAsks.map((element, index) => {
            const text = marked.parse(element.text);

            return (
              <div
                className={
                  element.type === "user"
                    ? "c-ia-conversation__ia-user-text-container"
                    : "c-ia-conversation__ia-text-container"
                }
                key={`${index}-${element.type}-${element.text}`}
                style={{
                  display: "flex",
                  justifyContent:
                    element.type === "user" ? "flex-end" : "flex-start",
                  marginTop: 10,
                }}
              >
                {element.type === "user" ? (
                  <div className="c-ia-conversation__ia-text-user-icon">
                    <IaUserIcon />
                  </div>
                ) : (
                  <div className="c-ia-conversation__ia-text-ia-icon">
                    <IaIcon />
                  </div>
                )}
                <p
                  className={
                    element.type === "user"
                      ? "c-ia-conversation__user-text"
                      : "c-ia-conversation__ia-text"
                  }
                  dangerouslySetInnerHTML={{
                    __html: text,
                  }}
                ></p>
              </div>
            );
          })}

          <h2 className="o-margin--bottom-size-l">{title}</h2>

          <div className="c-ia-conversation__ask-container">
            {exceedAsksLimitAvailable && (
              <div className="c-ia-conversation__ask-container-counter">
                {exceedAsksLimit ? (
                  <small>You have reached the maximum number of asks</small>
                ) : (
                  <small> {currentAsk}/<span>{maxAsks}</span> </small>
                )}
              </div>
            )}
            <Input
              name="ask"
              label="Ask"
              errorLabel=""
              minCharacters={5}
              showError={false}
              type="textarea"
              value={iaAskText}
              onChange={(e) => setIaAskText(e.target.value)}
            />
            <div className="c-button__wrapper">
              <button
                disabled={exceedAsksLimit}
                type="button"
                className="c-button c-modal__button"
                onClick={(event) => {
                  if (event.detail === 0) return false; // Avoid sending by clickcing on Enter button
                  sendIaAsk();
                }}
              >
                <span className="c-button__text">Send</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default IaConversation;
